import TextInputField from "components/common/Auth/TextInputField";
import SubmitButton from "components/common/Auth/SubmitButton";
import { useLogin } from "@/modules/Auth/hooks/useLogin";
import { translate } from "components/common/Translate/Translate";

const LoginForm = () => {
    const { register, handleSubmit, onSubmit, errors, pending } = useLogin();
    return (
        <form className="space-y-4" onSubmit={handleSubmit(onSubmit)}>
            {/* Email Field */}
            <TextInputField
                {...register("email")}
                type="text"
                title={translate("email-field-title")}
                placeholder={translate("email-field-title")}
                errorMsg={errors.email?.message}
                preventWhiteSpace={true}
                data-automation-id="LoginFormEmail"

            />
            {/* Password Field */}
            <TextInputField
                {...register("password")}
                type="password"
                title={translate("password-field-title")}
                placeholder={translate("password-field-title")}
                errorMsg={errors.password?.message}
                data-automation-id="LoginFormPassword"
            />

            <SubmitButton pending={pending} title={translate("login-button-title")} />
        </form>
    );
};
export default LoginForm;
